<template>
  <Grid align-content="start" gap="var(--r-space-sm)" class="basic-fields">
    <RInput v-model="basic.first_name" label="First name*" autofocus no-hint no-feedback-icon></RInput>
    <RInput v-model="basic.last_name" label="Last name*" no-hint no-feedback-icon></RInput>
    <RInput v-model="basic.email" label="Email*" no-hint no-feedback-icon></RInput>
    <RInput v-model="basic.job" label="Job" no-hint no-feedback-icon></RInput>
    <RInput v-model="basic.phone" label="Phone" no-hint no-feedback-icon></RInput>
    <RInput v-model="basic.mobile_phone" label="Mobile phone" no-hint no-feedback-icon></RInput>
  </Grid>
</template>

<script>
export default {
  props: {
    initialFields: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      basic: {
        first_name: this.initialFields.first_name || null,
        last_name: this.initialFields.last_name || null,
        email: this.initialFields.email || null,
        job: this.initialFields.job || null,
        phone: this.initialFields.phone || null,
        mobile_phone: this.initialFields.mobile_phone || null
      }
    }
  },

  methods: {
    //Access from parent
    getPayload() {
      return this.basic
    }
  }
}
</script>

<style lang="scss" scoped></style>
